document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const tbody = document.querySelector(
      "[bss-b2b-main-product-form] .bss-b2b-qty-table-wrapper tbody"
    );
    if (tbody) {
      const existing = tbody.querySelector("[bss-textqb]");
      if (existing) return;
      
      const newRow = document.createElement("tr");
      newRow.classList.add("bss-b2b-qty-table-row");

      const newCell = document.createElement("td");
      newCell.colSpan = 99;
      newCell.innerHTML = `<span bss-textqb>To place a half or full pallet order, please email our team directly.</span>`;

      newRow.appendChild(newCell);
      tbody.appendChild(newRow);
    }
  }, 2000);
});


document.addEventListener("cart-drawer:refreshed", function () {
  BSS_B2B.nt.initFunction()
 document.dispatchEvent(new Event("DOMContentLoaded"));
});
